import React, { useEffect, useState } from "react";
import placeHolderImage from '../assets/images/loading.gif'
import erroredImage from '../assets/images/placeholder.png'
import { ImageViewer } from "./imageViewer";
import { NoSymbolIcon } from "@heroicons/react/24/outline";
export type PlaceholderDimention = '1X1' | '2X3'
export const Img: React.FC<React.ImgHTMLAttributes<HTMLImageElement> & any> = ({
    src, alt, className, height, width, title, shouldOpenViewer = true
}) => {
    const [source, setSource] = useState(src)
    const [isOpen, setIsOpen] = useState(false)
    const [status, setStatus] = useState<number>(0)
    useEffect(()=>{
        setSource(src)
        setStatus(0)
        if(!src) {
            setStatus(1)
        }
    },[src])
    return (
        <div style={status === 0 ? {backgroundImage: `url(${placeHolderImage})`}: {}} className={`bg-center bg-contain bg-no-repeat flex items-center ${className}`} onClick={e=>e.stopPropagation()}>
            {
               shouldOpenViewer && <ImageViewer src={source ?? ''} isOpen={isOpen} setIsOpen={setIsOpen}> </ImageViewer>
            }

            {
                source ?
                <img className="w-full max-w-[100px] h-full object-contain cursor-pointer"
                onLoad={e=>{
                    setStatus(1)
                }}
                 onError={e=>{
                    setSource(erroredImage);
                    setStatus(1)
                }} onClick={()=>shouldOpenViewer ? setIsOpen(true) : 0} title={status === 2 ? 'Image Errored !': title} {... {src: source, alt}} />
                :
                <NoSymbolIcon className="h-full w-full text-gray-400"/>
            }
        </div>
    )
}